import { useState, useRef } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SidebarHeader from './SidebarHeader';
import SidebarItems from './SidebarItems';

const Sidebar = (props) => {
  const { items } = props;

  const [activeItem, setActiveItem] = useState(null);

  const shadowRef = useRef(null);

  const scrollMenu = (container) => {
    if (shadowRef && container.scrollTop > 0) {
      if (!shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.add('d-block');
      }
    } else {
      if (shadowRef.current.classList.contains('d-block')) {
        shadowRef.current.classList.remove('d-block');
      }
    }
  };

  return (
    <>
      <div className="main-menu menu-fixed menu-accordion menu-shadow menu-light">
        {/* Sidebar Header */}
        <SidebarHeader {...props} />
        {/* Sidebar Header Shadow */}
        <div className="shadow-bottom" ref={shadowRef}></div>
        {/* Perfect Scrollbar */}
        <PerfectScrollbar
          className="main-menu-content"
          options={{ wheelPropagation: false }}
          onScrollY={(container) => scrollMenu(container)}>
          <ul className="navigation navigation-main">
            <SidebarItems items={items} activeItem={activeItem} setActiveItem={setActiveItem} />
          </ul>
        </PerfectScrollbar>
      </div>
    </>
  );
};

export default Sidebar;
